module.exports = __webpack_public_path__ + "static/media/Apple iPhone X Space Grey.6064b6ec.png";